// extracted by mini-css-extract-plugin
var _1 = "_productManagementDiscountDelete-module__action-button-disabled";
var _2 = "_productManagementDiscountDelete-module__container";
var _3 = "_productManagementDiscountDelete-module__delete-button";
var _4 = "_productManagementDiscountDelete-module__loader";
export { _1 as "action-button-disabled", _2 as "container", _3 as "delete-button", _4 as "loader" }
